<template>
    <span>
        <button :class="getCSSClass('pdf-lightbox-button')"
                v-on:click="showPreview"
                type="button"
                v-html="label"
        ></button>
        <popup :visible="showPopup"
               v-on:close="showPopup = false">
            <div style="position: relative; min-height: 70vh; height: 100%;">
                <component :is="'PDFViewerComponent'" v-if="pdfUrl != null" :url="pdfUrl"></component>
            <button v-on:click="$emit('close'); showPopup = false"  v-html="'&times;'"
                :class="getCSSClass('document-previewer-close-button')"></button>

            </div>

        </popup>
    </span>
</template>

<script>
export default {
    inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon', 'mainButtons'],
    props: {
        operationsUrl: {type: String},
        filename: {type: String},
        label: {type: String}
    },
    data: function () {
        return {
            pdfUrl: null,
            showPopup: false,
        }
    },
    mounted() {
    },
    methods: {
        showPreview: function() {
            window.axios.post(this.operationsUrl, {
                operation: 'getDownloadLink',
                file: this.filename,
                version: null
            }).then((response) => {
                this.pdfUrl = response.data;
                this.showPopup = true;
            });
        }
    },
    computed: {},
    watch: {
    }

}
</script>
